import { render, staticRenderFns } from "./Sidrosan.vue?vue&type=template&id=6d74ce48&scoped=true"
import script from "./Sidrosan.vue?vue&type=script&lang=js"
export * from "./Sidrosan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d74ce48",
  null
  
)

export default component.exports